/**
 * 自社の広告のバナーの見本（作る ② の AI の案・④ の確認・数字の画面・運営の確認で同じものを出す）。
 *
 * 画像は selfAdsApi.bannerDataUrl で鍵つきで読んで data: にする（<img src> は鍵のヘッダを送れない・CSP は data: だけ許す）。
 * 画像がまだ無い・画像の口がまだ無い（約束への要望 2）・読めなかったときは、同じ大きさの枠に一文と「▶ Play」を描いた仮の見本を出す
 * = 「どこに・どのくらいの大きさで出るか」は画像が無くても分かる。仮の見本だと分かるように札を付ける（本物と取り違えない）。
 *
 * 大きさ: 320×50（スマホ）・728×90（PC）= 帯の決まった 2 つ（約束 §4 SelfAdPick.banners）。画面が狭いときは比率を保って縮める（CSS .ad-banner）。
 */
import { useEffect, useState } from 'react';
import { bannerDataUrl } from '../selfAdsApi';
import { useT } from '../i18n';

export function AdBanner({
  campaignId,
  size,
  assetId,
  tagline,
  name,
  staffToken
}: {
  campaignId: string;
  size: 320 | 728;
  /** null = この大きさのバナーはまだ無い */
  assetId: string | null;
  tagline: string | null;
  name: string;
  staffToken?: string;
}) {
  const { t } = useT();
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setSrc(null);
    setFailed(false);
    if (!assetId) return;
    let live = true;
    bannerDataUrl(campaignId, size, staffToken)
      .then((u) => live && setSrc(u))
      .catch(() => live && setFailed(true));
    return () => {
      live = false;
    };
    // assetId が変わった = 作り直した → 読み直す
  }, [campaignId, size, assetId, staffToken]);

  const h = size === 320 ? 50 : 90;
  const label = t(size === 320 ? 'ssa.banner.phone' : 'ssa.banner.computer');
  return (
    <figure className={`ad-banner ad-banner-${size}`}>
      <figcaption className="small muted">
        {label} <span className="mono">{`${size}×${h}`}</span>
      </figcaption>
      {src ? (
        <img src={src} width={size} height={h} alt={tagline ?? name} className="ad-banner-img" />
      ) : (
        // 仮の見本（画像が無い・読めない）。文の長さが帯に収まるかもここで分かる
        <div className="ad-banner-mock" style={{ aspectRatio: `${size} / ${h}` }} aria-label={tagline ?? name}>
          <span className="ad-banner-art" aria-hidden="true" />
          <span className="ad-banner-line">{tagline || name}</span>
          <span className="ad-banner-cta" aria-hidden="true">
            ▶ {t('ssa.banner.play')}
          </span>
          <span className="ad-banner-tag">{assetId && !failed ? t('ssa.banner.loading') : assetId ? t('ssa.banner.sample') : t('ssa.banner.none')}</span>
        </div>
      )}
    </figure>
  );
}
